















import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/Modal.scss';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
@Component({
    props: {
        id: String,
    },
})
export default class ViewDocumentModal extends Vue {
    private show = true;
    private fileURL = '';
    private imageUrl = '';

    public async mounted() {
        this.displayDocument();
    }

    private async displayDocument() {
        const iHttpService = ObjectFactory.getHttpService();
        const fileName: string = this.$props.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${encodeURIComponent(fileName)}`,
            loaderEvent: {
                show: true,
            },
            responseType: 'arraybuffer',
        };
        const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
        if (fileName.toLowerCase().endsWith('.pdf')) {
            const file = new Blob([fileBuffer], {type: 'application/pdf'});
            this.fileURL = URL.createObjectURL(file);
        } else {
            const file = new Blob([fileBuffer], {type: 'application/png'});
            this.imageUrl = URL.createObjectURL(file);
        }

    }

    private close() {
        this.$emit('close');
    }

}
